import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {Form} from 'formik';

import {
  cancelEditTestScore,
  deleteTestScore,
  scrolledToScore,
} from 'shared/portfolio/actions/test-scores';

import PortfolioFormFooter from 'src/components/PortfolioFormFooter';
import FormCard from '../form-card';
import TestScoresFormWrapper, {
  TestScoreForm as TestScoreFormType,
} from './test-scores-form-wrapper';
import TestScoreInputs from './test-score-inputs';

export const TEST_SCORE_NAME_MAP = {
  actPlan: 'ACT Plan',
  preAct: 'PreACT',
  act: 'Legacy ACT',
  act2025: 'ACT',
  ap: 'AP',
  psat2015: 'PSAT',
  psat: 'PSAT',
  sat2016: 'SAT',
  sat: 'SAT',
};

interface Props {
  testScore: TestScoreFormType;
}

const TestScoreForm = ({testScore}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (testScore.scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToScore(testScore._id));
      }, 550);
    }
  }, [dispatch, testScore._id, testScore.scrollTo]);

  return (
    <FormCard ref={ref} id={testScore._id}>
      <TestScoresFormWrapper initialValues={testScore}>
        {({values}) => (
          <Form autoComplete="off" noValidate>
            <h4 className="portfolio-sections add-edit-header">
              {values.new ? 'Add' : 'Edit'}{' '}
              {values.type ? TEST_SCORE_NAME_MAP[values.type] : 'Test'} Score
            </h4>

            <TestScoreInputs />

            {values.type && (
              <PortfolioFormFooter
                _id={testScore._id}
                onDelete={() => dispatch(deleteTestScore(testScore._id))}
                onCancel={() => dispatch(cancelEditTestScore(testScore))}
                formName="portfolio test-scores activity-form"
              />
            )}
          </Form>
        )}
      </TestScoresFormWrapper>
    </FormCard>
  );
};

export default TestScoreForm;
